import { Alert } from 'antd'
import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isEmpty, isLoaded, withFirebase } from 'react-redux-firebase'
import { push } from 'react-router-redux'
import { withHandlers } from 'recompose'
import { compose } from 'redux'

import { associateDeviceWithFlight } from '../../actions/deviceAuth'
import { playground } from '../../constants/playgrounds'
import { findInOrdered, fsCollections } from '../../helpers/firestore'
import routes from '../../helpers/routes'
import { Spinner } from '../higher-order/spinner'
import MobileFlightResults from './MobileFlightResults'

class FlightResultsApp extends React.Component<any, any> {
  /**
   * Force user identity - use anonymous login in case no user is currently signed-in
   */
  componentWillReceiveProps(nextProps) {
    const { auth, firebase, secret, dropSecret, authorizeDevice } = nextProps
    if (isLoaded(auth) && isEmpty(auth)) {
      firebase.auth().signInAnonymously()
    }

    if (auth.uid && secret) {
      dropSecret()
      authorizeDevice(secret)
    }
  }

  render() {
    const { auth, flight, deviceAuthPending } = this.props

    if (!auth.uid || !isLoaded(flight) || deviceAuthPending) {
      return <Spinner />
    }

    if (auth.uid !== flight.authorizedDevice) {
      return (
        <Alert
          message="Unauthorized Device"
          description="This device can no longer be used to record results for your flight. Please contact tournament organizer to assist you."
          type="warning"
          showIcon
        />
      )
    }

    return <MobileFlightResults {...this.props} playground={playground} />
  }
}

export default compose<FIXME>(
  withFirebase,
  firestoreConnect<FIXME>(({ tenant, tournamentId, flightId }) => [
    { collection: fsCollections.tournamentFlights(tenant, tournamentId), doc: flightId },
  ]),
  connect(
    (
      { firebase: { auth }, firestore, deviceAuth: { pending } }: FIXME,
      { tenant, tournamentId, flightId }: FIXME,
    ) => ({
      auth,
      flight: findInOrdered(
        firestore.ordered[fsCollections.tournamentFlights(tenant, tournamentId)],
        flightId,
      ),
      deviceAuthPending: pending,
    }),
  ),
  withHandlers({
    /* authorize this device for writes of results  */
    authorizeDevice: ({ tenant, tournamentId, dispatch, flightId, auth }) => (secret) =>
      dispatch(
        associateDeviceWithFlight({ tenant, tournamentId, flightId, secret, uid: auth.uid }),
      ),

    /* secret is transferred through URL fragment; this function clears it */
    dropSecret: ({ tenant, tournamentId, flightId, dispatch }) => () =>
      dispatch(push(routes.flightResults(tenant, tournamentId, flightId))),
  }),
)(FlightResultsApp)



// WEBPACK FOOTER //
// ./src/components/mobile/FlightResultsApp.tsx